import React from 'react';

function LightIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? '24'}
      height={props.size ?? '24'}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={props.color ?? '#000'}
        d="M17.09 2.821a8 8 0 00-6.68-1.66 8 8 0 00-6.27 6.32 8.07 8.07 0 001.72 6.65A4.54 4.54 0 017 17.001v3a3 3 0 003 3h4a3 3 0 003-3v-2.81a5.17 5.17 0 011.22-3.19 8 8 0 00-1.13-11.2v.02zM15 20.001a1 1 0 01-1 1h-4a1 1 0 01-1-1v-1h6v1zm1.67-7.24a7.13 7.13 0 00-1.67 4.24h-2v-3a1 1 0 10-2 0v3H9a6.5 6.5 0 00-1.6-4.16 6 6 0 013.39-9.72A6 6 0 0118 9.001a5.89 5.89 0 01-1.33 3.76z"
      ></path>
    </svg>
  );
}

export default LightIcon;
